import { render, staticRenderFns } from "./UDRadioCell.vue?vue&type=template&id=020d2f06&"
import script from "./UDRadioCell.vue?vue&type=script&lang=js&"
export * from "./UDRadioCell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports